export default "__VITE_ASSET__454e5c5b__"